import React from 'react'
import { Helmet , HelmetProvider } from 'react-helmet-async'
import WithConfig from '../wrappers/withConfig'

const Header = ({ config }) => {
    const { APP_TITLE } = config
    return (
        <HelmetProvider>
            <Helmet>
                <title>{APP_TITLE}</title>
            </Helmet>
        </HelmetProvider>
    )
}

export default WithConfig(Header)